import {test} from "@/config/config"
import { setSecret } from '@blazes/crypto'
import axios from 'axios'
import { Toast } from '@/lib/toast'
import { appId, signKey } from '@/config/config'

import { sign, SIGN_AUTHORIZATION, getDate, getRandom16Nonce } from '@blazes/crypto/dist/sign'
import store from '@/store'
import config from '@/config/config'

let txtconfig = config[store.state.curLan]
let frontEndApiHost = test ? 'https://market-mirror.pandadagames.com' : 'https://market.pandadagames.com'
let apiHost = test ? 'https://webaccount-mirror.pandadagames.com' : 'https://webaccount.pandadagames.com'
// let frontEndApiHost = 'https://market.pandadagames.com';
// let apiHost = 'https://webaccount.pandadagames.com';

const spAxios = axios.create()
const norAxios = axios.create()


spAxios.defaults.baseURL = apiHost
norAxios.defaults.baseURL = frontEndApiHost

spAxios.defaults.timeout = 10 * 60 * 1000
norAxios.defaults.timeout = 10 * 60 * 1000

const requestInterceptorsSuccess = (config) => {
	return config
}
const requestInterceptorsFail = (error) => {
	return Promise.reject(error)
}
const responseInterceptorsSuccess = (response) => {
	// console.log(response)
	if (response.status == 200) {
		// let code = response.data.code

		return Promise.resolve(response)
	} else {
		return Promise.reject(response)
	}
}
const responseInterceptorsFail = (error) => {
	console.log('请求错误！' + error)
}

spAxios.interceptors.request.use(requestInterceptorsSuccess, requestInterceptorsFail)

spAxios.interceptors.response.use(responseInterceptorsSuccess, responseInterceptorsFail)

norAxios.interceptors.request.use(requestInterceptorsSuccess, requestInterceptorsFail)

norAxios.interceptors.response.use(responseInterceptorsSuccess, responseInterceptorsFail)

const header = {
	'x-yh-date': getDate(),
	'x-yh-nonce': getRandom16Nonce(),
	'x-yh-appid': appId,
	'x-yh-traceid': getRandom16Nonce()
	// "x-yh-package":'com.pandadastudio.ninjamustdie.tc',
	// "x-yh-sdk-device":'18552d05-46e0-393e-9c12-b5d9645fe9b6'
}

setSecret({
	sign: signKey
})

function getSignCode(method, url, data) {
	const parsedUrl = new URL(apiHost + url)
	console.log('parsedUrl', parsedUrl)
	let search = ''
	let formData = ''

	if (parsedUrl.search) {
		search = parsedUrl.search.split('?')[1]
	}
	if (data) {
		// formData = new FormData()
		// for(var i = 0;i < Object.keys(data).length;i++){
		//   formData.append(Object.keys(data)[i],data[Object.keys(data)[i]])
		// }
		formData = JSON.stringify(data)
		console.log(formData)
	}
	return {
		verb: method,
		host: parsedUrl.host,
		path: parsedUrl.pathname,
		query: search,
		header: header,
		body: formData
	}
}

function getSignCode2(method, url, data) {
	const parsedUrl = new URL(frontEndApiHost + url)
	console.log('parsedUrl2', parsedUrl)
	let search = ''
	let formData = ''

	if (parsedUrl.search) {
		search = parsedUrl.search.split('?')[1]
	}
	if (data) {
		// formData = new FormData()
		// for(var i = 0;i < Object.keys(data).length;i++){
		//   formData.append(Object.keys(data)[i],data[Object.keys(data)[i]])
		// }
		formData = JSON.stringify(data)
		console.log(formData)
	}
	return {
		verb: method,
		host: parsedUrl.host,
		path: parsedUrl.pathname,
		query: search,
		header: header,
		body: formData
	}
}

export default {
	//直接对接忍3后端带签名的post请求
	spPost(url, data) {
		return new Promise((resolve, reject) => {
			const beSigned = getSignCode('POST', url, data)
			sign(beSigned, signKey).then((authorization) => {
				let config = {
					method: 'POST',
					url: url,
					data: data,
					headers: {
						...header,
						Authorization: `${SIGN_AUTHORIZATION}${authorization}`
					}
				}
				spAxios(config)
					.then((res) => {
						if (res.status == 200) {
							resolve(res)
						} else {
							reject(res)
						}
					})
					.catch((err) => {
						console.log(err)
						Toast.showToast(txtconfig['networkErr'], 2000)
					})
			})
		})
	},
	//直接对接忍3后端带签名的get请求
	spGet(url, data) {
		return new Promise((resolve, reject) => {
			// let parme = '?'
			// if (data) {
			//   for (var i = 0; i < Object.keys(data).length; i++) {
			//     parme += Object.keys(data)[i] + '=' + data[Object.keys(data)[i]] +
			//       (i == Object.keys(data).length - 1 ? '' : '&')
			//   }
			// }
			console.log('url:', url)

			const beSigned = getSignCode('GET', url)
			console.log('sign:', sign(beSigned, signKey))
			console.log('sign fn:', sign)
			sign(beSigned, signKey).then((authorization) => {
				spAxios({
					method: 'GET',
					url: url,
					params: data,
					withCredentials: true,
					headers: {
						...header,
						Authorization: `${SIGN_AUTHORIZATION}${authorization}`
					}
				})
					.then((res) => {
						if (res.status == 200) {
							resolve(res)
						} else {
							reject(res)
						}
					})
					.catch((err) => {
						console.log(err)
						Toast.showToast(txtconfig['networkErr'], 2000)
					})
			})
		})
	},
	//直接对接忍3后端带签名的get请求
	spGet2(url, data) {
		return new Promise((resolve, reject) => {
			// let parme = '?'
			// if (data) {
			//   for (var i = 0; i < Object.keys(data).length; i++) {
			//     parme += Object.keys(data)[i] + '=' + data[Object.keys(data)[i]] +
			//       (i == Object.keys(data).length - 1 ? '' : '&')
			//   }
			// }
			// const beSigned = getSignCode('GET', url + "?uid="+ data.uid)
			let beSigned = getSignCode2('GET', url)
			if (url.indexOf('apis/v1/web/bind') > -1) {
				beSigned = getSignCode2('GET', url + '?uid=' + data.uid)
			}
			if (url.indexOf('apis/v1/web/auth/url') > -1) {
				beSigned = getSignCode2('GET', url + '?uid=' + data.uid)
			}
			if (url.indexOf('apis/v1/web/auth/twitch_account') > -1) {
				beSigned = getSignCode2('GET', url + '?code=' + data.code + '&state=' + data.state)
			}

			console.log('besigned', beSigned)
			sign(beSigned, signKey).then((authorization) => {
				norAxios({
					method: 'GET',
					url: '/twitch-drops' + url,
					params: data,
					withCredentials: true,
					headers: {
						...header,
						Authorization: `${SIGN_AUTHORIZATION}${authorization}`
					}
				})
					.then((res) => {
						if (res.status == 200) {
							resolve(res)
						} else {
							reject(res)
						}
					})
					.catch((err) => {
						console.log(err)
						Toast.showToast(txtconfig['networkErr'], 2000)
					})
			})
		})
	},
	spPost2(url, data) {
		return new Promise((resolve, reject) => {
			const beSigned = getSignCode2('POST', url, data)
			sign(beSigned, signKey).then((authorization) => {
				let config = {
					method: 'POST',
					url: '/twitch-drops' + url,
					data: data,
					headers: {
						...header,
						Authorization: `${SIGN_AUTHORIZATION}${authorization}`
					}
				}
				norAxios(config)
					.then((res) => {
						if (res.status == 200) {
							resolve(res)
						} else {
							reject(res)
						}
					})
					.catch((err) => {
						console.log(err)
						Toast.showToast(txtconfig['networkErr'], 2000)
					})
			})
		})
	},
	get(url, data, header) {
		return new Promise((resolve, reject) => {
			if (!data) {
				data = {}
			}

			norAxios({
				method: 'GET',
				url: url,
				params: data,
				withCredentials: true,
				headers: {
					token: store.state.token,
					...header,
					'x-yh-appid': appId
				}
			})
				.then((res) => {
					if (res.status == 200) {
						resolve(res)
					} else {
						reject(res)
					}
				})
				.catch((err) => {
					console.log(err)
					Toast.showToast(txtconfig['networkErr'], 2000)
				})
		})
	},
	getNoNeedToken(url, data) {
		return new Promise((resolve, reject) => {
			norAxios({
				method: 'GET',
				url: url,
				params: data,
				withCredentials: true,
				headers: {
					'x-yh-appid': appId
				}
			})
				.then((res) => {
					if (res.status == 200) {
						resolve(res)
					} else {
						reject(res)
					}
				})
				.catch((err) => {
					console.log(err)
					Toast.showToast(txtconfig['networkErr'], 2000)
				})
		})
	},
	post(url, data) {
		return new Promise((resolve, reject) => {
			let config = {
				method: 'POST',
				url: url,
				data: data,
				withCredentials: true,
				headers: {
					'x-yh-appid': appId
				}
			}

			norAxios(config)
				.then((res) => {
					if (res.status == 200) {
						resolve(res)
					} else {
						reject(res)
					}
				})
				.catch((err) => {
					console.log(err)
					Toast.showToast(txtconfig['networkErr'], 2000)
				})
		})
	}
}
